import {useCallback} from 'react';

import logError from 'src/utils/errors/logError';

import {firestoreDB} from '@/services/firebase/initializeFirebase';

const authByPassCollection = 'authByPass';

interface IAuthByPass {
  id: string;
  isEnabled: boolean;
  reason: string;
}

export const useFirestoreAuth = () => {
  const handleGetAuthByPass = useCallback(async () => {
    try {
      const snapshot = await firestoreDB
        .collection(authByPassCollection)
        .where('isEnabled', '==', true)
        .get();
      if (snapshot.empty) {
        return [];
      }
      const authByPassData = snapshot.docs.map(doc => {
        return {
          id: doc.id,
          ...doc.data(),
        } as IAuthByPass;
      });
      return authByPassData;
    } catch (error) {
      logError(error, {
        fileName: 'useFirestoreAuth.ts',
        functionName: 'handleGetAuthByPass',
        customTitle:
          'Auth - AuthByPass - Failed to fetch authByPass collection',
      });
      return [];
    }
  }, []);
  return {
    handleGetAuthByPass,
  };
};
